import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AuthContext } from "./Contexts/AuthContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {FaChartBar } from 'react-icons/fa';
import { FaCow } from "react-icons/fa6";
import { MdMobileFriendly } from "react-icons/md";
import { api } from "./api";
import './dash.css'
import SocialLogin from "./SocialLogin/SocialLogin";

export default function Dash() {
    const { user, login, logout } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const [success, setSuccess] = useState(null);
    const navigate = useNavigate();
    const [form, setForm] = useState({
        email: "",
        password: ""
    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [checking, setChecking] = useState(true); 

    useEffect(() => {
        const verified = searchParams.get("verified");
        if (verified === "success") {
            setSuccess("Email vérifié avec succès! Vous pouvez maintenant vous connecter.");
        }
    }, [searchParams]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token && user) {
            navigate("/" + user.role);
        } else {
            setChecking(false);
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const res = await axios.post(api+"login", form);
            login(res.data.user); 
            localStorage.setItem("token", res.data.token);
            if (res.data.user.role === "admin") {
                navigate("/admin");
            } else {
                navigate("/eleveur");
            }
        } catch (err) {
            setError(err.response?.data?.message || "Erreur de connexion");
        } finally {
            setLoading(false);
        }
    };

    

    return (
        <div className="login-page">
            <div className="login-left">
                <div className="login-content">
                    <div className="logo-section">
                        <div className="logo-icon"><FaCow /></div>
                        <h1 className="logo-text">Gestion des Animaux</h1>
                    </div>

                    
                    <div className="welcome-text">
                        <h2>Bienvenue</h2>
                        <p>Connectez-vous pour gérer votre élevage</p>
                    </div>

                    {success && (
                        <div className="success-message">
                            {success}
                        </div>
                    )}


                    {error && (
                        <div className="error-message">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                            </svg>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="input-group">
                            <label htmlFor="email">Email</label>
                            <div className="input-wrapper">
                                <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <input
                                    id="email"
                                    className="input-field"
                                    type="email"
                                    name="email"
                                    placeholder="Votre email..."
                                    value={form.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-group">
                            <label htmlFor="password">Mot de passe</label>
                            <div className="input-wrapper">
                                <svg className="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                                </svg>
                                <input
                                    id="password"
                                    className="input-field"
                                    type="password"
                                    name="password"
                                    placeholder="Votre mot de passe..."
                                    value={form.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <button
                            className="submit-button"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <svg className="spinner" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeDasharray="50.265" strokeDashoffset="25" />
                                    </svg>
                                    Connexion en cours...
                                </>
                            ) : (
                                <>
                                    Se connecter
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                </>
                            )}
                        </button>

                        <div className="form-footer">
                            <p>
                                Vous n'avez pas encore un compte?{' '}
                                <a href="/signup" className="link-primary">s'inscrire</a>
                            </p>
                        </div>
                    </form>
                    <SocialLogin />
                </div>
            </div>

            <div className="login-right">
                <div className="hero-content">
                    <div className="hero-badge">
                        <span className="badge-dot"></span>
                        Gestion Intelligente
                    </div>
                    
                    <h1 className="hero-title">
                        Gérez votre ferme
                        <span className="gradient-text">avec efficacité</span>
                    </h1>
                    
                    <p className="hero-description">
                        Suivez vos animaux, gérez les reproductions et optimisez votre production en temps réel
                    </p>

                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon"><FaChartBar /></div>
                            <h3>Statistiques en temps réel</h3>
                            <p>Visualisez vos données instantanément</p>
                        </div>
                        
                        <div className="feature-card">
                            <div className="feature-icon"><MdMobileFriendly /></div>
                            <h3>Accès mobile</h3>
                            <p>Gérez votre ferme où que vous soyez</p>
                        </div>
                    </div>
                </div>

                <div className="bg-decoration decoration-1"></div>
                <div className="bg-decoration decoration-2"></div>
                <div className="bg-decoration decoration-3"></div>
                <div className="bg-grid"></div>
            </div>
        </div>
    );
}